module.exports = window.$bonelibs.Moment_2;